module.exports = __webpack_public_path__ + "static/media/content_creation_large.43a6b25c.svg";